<div style="padding: 24px">
    <mat-radio-group
        [formControl]="ohrmarkePassCtrl"
        style="display: flex; align-items: center; justify-content: space-around; width: 100%; margin-bottom: 12px"
    >
        <mat-radio-button [value]="0">Ohrmarken</mat-radio-button>
        <mat-radio-button [value]="1">P&auml;sse</mat-radio-button>
    </mat-radio-group>
    <div class="one-row">
        <mat-form-field class="no-padding-margin-mat-form-field" style="width: 100%; margin-bottom: 6px">
            <mat-label
                >{{ ohrmarkePassCtrl.value === 0 ? "Ohrmarke " : "Pass " }}
                scannen
            </mat-label>
            <input
                #ohrenmarkeInput="matInput"
                (keyup.enter)="addOhrmarkePass($event)"
                [formControl]="ohrenmarkeCtrl"
                matInput
                maxlength="{{ maxLengthOhrmarke }}"
                type="text"
            />
            <span matSuffix style="font-size: 0.8em">{{ ohrenmarkeCtrl.value?.length }}/{{ maxLengthOhrmarke }}</span>
            <button
                (click)="addOhrmarkePass($event)"
                *ngIf="canSubmitScan"
                mat-icon-button
                matSuffix
            >
                <mat-icon>check</mat-icon>
            </button>
            <button
                *ngIf="!canSubmitScan"
                [disabled]="true"
                mat-icon-button
                matSuffix
            ></button>
        </mat-form-field>
    </div>

    <div class="one-row">
        <div class="one-row" style="width: 90%; justify-content: start">
            <mat-slide-toggle [formControl]="mitGewichtToggleCtrl"></mat-slide-toggle>
            <p
                (click)="mitGewichtToggleCtrl.setValue(!mitGewichtToggleCtrl.value)"
                style="font-size: 0.8em; margin-left: 3px"
            >
                mit Gewicht oder Abteil
            </p>
        </div>

        <span class="spacer"></span>
    </div>

    <div style="flex-grow: 1"></div>

    <div class="abgang-scan-history">
        <h3>Zuletzt gescannt:</h3>
        <p *ngIf="gescannteOhrmarken?.length < 1">---</p>
        <ul class="abgang-scan-history__list">
            <li [@openClose]="openCloseState" class="ohrenmarke-list-item ohrenmarke-list-item--latest">
                <div *ngIf="gescannteOhrmarken?.length > 0" class="ohrenmarke-list-item-row">
                    <mat-icon
                        class="ohrenmarke-list-item__status"
                        [style.color]="gescannteOhrmarken[0].success ? 'green' : '#9b0024'"
                    >
                        {{ gescannteOhrmarken[0].success ? "check" : "error" }}
                    </mat-icon>
                    <div class="ohrenmarke-list-item--text">
                        <kiene-ohrmarke [ohrmarke]="gescannteOhrmarken[0].ohrmarke" style="font-size: 0.8em">
                        </kiene-ohrmarke>
                    </div>
                </div>
            </li>
            <li *ngFor="let ohrmarke of gescannteOhrmarken; let i = index" class="ohrenmarke-list-item">
                <div *ngIf="i > 0" class="ohrenmarke-list-item-row">
                    <mat-icon class="ohrenmarke-list-item__status" [style.color]="ohrmarke.success ? 'green' : '#9b0024'">
                        {{ ohrmarke.success ? "check" : "error" }}
                    </mat-icon>
                    <div class="ohrenmarke-list-item--text">
                        <kiene-ohrmarke [ohrmarke]="ohrmarke.ohrmarke" style="font-size: 0.8em"> </kiene-ohrmarke>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</div>
